












































import { Component, Vue } from 'vue-property-decorator'
import CalculateStore from '@/stores/CalculateStore'
import ShipmentPoint from '@/dto/deliveries/ShipmentPoint'
import ShipmentStore from '@/stores/ShipmentStore'
import ShipmentPointsGroup from '@/dto/deliveries/ShipmentPointsGroup'
import { singleCountryIds } from '@/services/shipmentPointLabel'

@Component({ inheritAttrs: false })
export default class FromShipmentPointSelect extends Vue {
  isPopupShow = false

  get shipmentPoint(): ShipmentPoint | null {
    return CalculateStore.shipmentPoint
  }

  set shipmentPoint(point: ShipmentPoint | null) {
    if (point) {
      CalculateStore.setShipmentPoint(point)
    }
  }

  get groups(): ShipmentPointsGroup[] {
    return ShipmentStore.pointsGroupsAsArray
  }

  get singleCountryIds(): Set<number> {
    return singleCountryIds(this.groups)
  }

  getOptionLabel(point: ShipmentPoint): string {
    // Страна с единственной точкой → показываем страну вместо города.
    if (this.singleCountryIds.has(point.country.id)) {
      return point.country.name
    }

    return this.isPopupShow
      ? point.city.name
      : `${point.city.name} / ${point.country.name}`
  }
}
